import * as request from '@/utils/request'
const BASE_URL = '/paas/company_djg_user/white_list'

export default {
	/**
	 * @description 董监高
	 * @author daihua
	 * @date 2022/4/13
	 * @param {*} data
	 * @returns
	 */
	//创建
	postCompany_djg_userList(data) {
		return request.post(`${BASE_URL}/create`, data)
	},
	//列表
	getCompany_djg_userlist(data) {
		return request.get(`${BASE_URL}/list`, data)
	},
	//删除
	deleteCompany_djg_userID(id){
		return request.Delete(`${BASE_URL}/delete/${id}`)
	}
}
